import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=94f648b6&"
import script from "./AddProducts.vue?vue&type=script&lang=js&"
export * from "./AddProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports